import React from "react";
import PropTypes from "prop-types";

import { Header } from "semantic-ui-react";

import SettingsToggleRow from "../NotificationSettings/SettingsToggleRow";

function ExperimentToggle({
  settingKey,
  title,
  message,
  toggleLabel,
  helperText,
  checked,
  loading,
  onChange,
}) {
  return (
    <div style={{ marginTop: "1em" }}>
      <Header as="h3" style={{ marginBottom: "0" }}>
        {title}
      </Header>
      <h4 style={{ marginTop: "0.7em" }}>{message}</h4>
      <SettingsToggleRow
        renderData={{
          key: settingKey,
          title: toggleLabel,
          description: helperText,
        }}
        loading={loading}
        checked={checked}
        setPreference={(_, isChecked) => {
          return onChange(isChecked);
        }}
      />
    </div>
  );
}

ExperimentToggle.propTypes = {
  settingKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  toggleLabel: PropTypes.string.isRequired,
  helperText: PropTypes.node.isRequired,
  checked: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ExperimentToggle;
